export default "__VITE_ASSET__DHPgdcM___"